type Method = 'key' | 'shield' | 'link' | 'email' | 'device';

/** Decorative icon for account settings; text remains the accessible label. */
export function SecurityMethodIcon({ method }: { method: Method }) {
  return <span className="security-method-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {method === 'key' ? <><circle cx="15.5" cy="8.5" r="4.5" /><path d="M12.2 11.8 4 20v-3l2-2h2v-2h2l2.2-2.2M17 7h.01" /></> : null}
      {method === 'shield' ? <path d="M12 3 20 6v5c0 4.6-3.2 8.1-8 10-4.8-1.9-8-5.4-8-10V6l8-3Z" /> : null}
      {method === 'link' ? <><path d="M9.5 14.5 14.5 9.5" /><path d="M7.3 16.7 6 18a3.5 3.5 0 0 1-5-5l4-4a3.5 3.5 0 0 1 5 0M16.7 7.3 18 6a3.5 3.5 0 0 1 5 5l-4 4a3.5 3.5 0 0 1-5 0" transform="translate(0 0)" /></> : null}
      {method === 'email' ? <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /></> : null}
      {method === 'device' ? <><rect x="4" y="4" width="16" height="12" rx="1.5" /><path d="M2 20h20M9 16v4M15 16v4" /></> : null}
    </svg>
  </span>;
}
